// -------------------------- OTP PROPS -------------------------- //

export interface CanaisOtp {
  sms: boolean
  email: boolean
}

export interface OtpInitData {
  otp_session_token: string
  canais: CanaisOtp
  expira_em: string
}

export interface ValidateOtpOk {
  retorno: true
  hash_unico: string
  redirect: string
}

export interface ResendOtpOk {
  retorno: true
  canais: CanaisOtp
  expira_em: string
}

export interface OtpError {
  retorno: false
  message: string
}

export interface OtpApiResult<T> {
  status: number
  body: T | OtpError
}

export function isOtpError(body: unknown): body is OtpError {
  return (
    typeof body === 'object' &&
    body !== null &&
    'retorno' in body &&
    (body as { retorno: unknown }).retorno === false
  )
}

export interface OtpModalCallbacks {
  /** Validação 200. O pai executa o redirect usando payload.redirect. */
  onSuccess: (payload: ValidateOtpOk) => void
  /** Reenvio 200 (informativo). */
  onResend: (canais: CanaisOtp, expira_em: string) => void
  /** Fechamento manual (ESC/backdrop). Exige refazer o init. */
  onCancel: () => void
  /** Falha terminal (422 do validar: limite/sessão inválida/bloqueado). */
  onError: (motivo: string) => void
}

// -------------------------- CARTÃO OTP PROPS -------------------------- //
export interface PurchaseSummaryParams {
  retorno: boolean
  valor: string
  descricao: string
  nome: string
  expira_em: string
}
 
export interface CardRegisterDados {
  token: string
  [chave: string]: unknown
}
 
export interface CardRegisterResponse {
  retorno: boolean
  mensagem: string
  dados: CardRegisterDados
}
 
export interface CartaoPagarResponse {
  retorno: boolean
  mensagem: string
  id?: string
  info?: { id: string }
  cartao_de_credito?: string
  [chave: string]: unknown
}
 
export interface HttpResult<T> {
  status: number
  body: T
}

export interface HttpAnswer {
  status?: number
  data?: unknown
}